import React from 'react';

function Success() {
   return (
      <div className="container d-flex flex-column align-items-center justify-content-center text-center mt-5 p-4  rounded">
         <h1 className="text-success mb-3">Thank You!</h1>
         <p className="lead">
            We appreciate your review. Your feedback helps us improve and serve you better.
         </p>
      </div>
   );
}

export default Success;
